import { toast } from 'react-toastify';
import './toastifyStyles.css';


const toastMiddleware = store => next => action => {
  // Continue processing the action
  const result = next(action);
  // Global toast handling based on action type
  switch (action.type) {
    case "api/email/fulfilled":
      toast.success('Your email has been sent.', {
				progressClassName: 'custom-progress-bar',
			});
      break;

    case "api/email/rejected":
      toast.error(`Error: ${action.payload}`);
      break;

    case "api/join/fulfilled":
      toast.success('You have been successfully added to the email list.', {
        progressClassName: 'custom-progress-bar',
      });
      break;
    case "graphql/createuser/fulfilled":
      toast.success('You have successfully created your user account.', {
        progressClassName: 'custom-progress-bar',
      });
      break;

    case "api/join/rejected":
      toast.error(`Error: ${action.payload}`);
      break;
    case "graphql/createuser/rejected":
      toast.error(`Error: ${action.payload}`);
      break;

    default:
      break;
  }

  return result;
};

export default toastMiddleware;
